module.exports = __webpack_public_path__ + "img/back_m_active3.5cef9c2e.png";